import { HomeSearchOutlineIcon } from './HomeSearchOutlineIcon';

/**
 * author: Michael Irigoyen
 * id D261AFB1-2C65-41D6-AE5A-E25D2FC120ED
 * name home-search-outline
 * version: 5.0.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-search-outline.svg
 * tags
 * - Home Automation 
 */
export const HouseSearchOutlineIcon = HomeSearchOutlineIcon;
export default HouseSearchOutlineIcon